import { FinalGridContainer, FinalGridItem } from '@portals/core/src/components/FinalGrid/FinalGrid';
import { LoadingDots } from '@portals/core/src/components/LoadingDots/LoadingDots';
import { getFixedT } from 'i18next';
import React, { useContext, useMemo } from 'react';

import { CockpitBox, EstateBookmarkedListEmptyList, EstateCardItem } from '../../../components';
import { BookmarkContext } from '../../../context';
import { useCockpitAccess, useFetchEstatesByIds } from '../../../hooks';
import { getBookmarkIds } from '../../../utils';
import { EstateListViewRenderProps } from '../../EstateListView/EstateListView.types';

const t = getFixedT(null, 'core-immobilien', 'watchlist.cockpit.estates');

export const EstateBookmarkedList: React.FC<Omit<EstateListViewRenderProps, 'isBookmarkedList'>> = ({
  renderBookmarkButton,
  renderEstateLink,
}) => {
  const { bookmarks } = useContext(BookmarkContext);
  const estateIds = useMemo(() => (bookmarks.length ? getBookmarkIds(bookmarks) : null), [bookmarks]);
  const { estates, isFetching } = useFetchEstatesByIds({ estateIds });
  const { isCockpitAccessEnabled } = useCockpitAccess();

  if (isFetching) {
    return <LoadingDots />;
  }

  if (!estateIds || estates.length === 0) {
    return (
      <FinalGridContainer>
        <FinalGridItem xs={12} sm={12} md={12} lg={12} sx={{ textAlign: 'center' }}>
          <EstateBookmarkedListEmptyList />
        </FinalGridItem>
      </FinalGridContainer>
    );
  }

  return (
    <FinalGridContainer>
      {estates.map((estate, index) => {
        const estateItem = <EstateCardItem {...estate} bookmarkButton={renderBookmarkButton?.(estate.id, 'small')} />;
        return (
          <FinalGridItem key={estate.id} xs={12} sm={4} md={4} lg={4} sx={{ order: index * 2 }}>
            {renderEstateLink ? renderEstateLink(estate.id, estateItem) : estateItem}
          </FinalGridItem>
        );
      })}
      {isCockpitAccessEnabled && (
        <FinalGridItem xs={12} sm={4} md={4} lg={4} sx={{ order: 3 }}>
          <CockpitBox title={t('title')} content={t('content')} />
        </FinalGridItem>
      )}
    </FinalGridContainer>
  );
};

EstateBookmarkedList.displayName = 'EstateBookmarkedList';
